import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { REVEAL_DATE } from "@/constants/config";

const getTimeLeft = () => {
  const diff = new Date(REVEAL_DATE).getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff / 3600000) % 24),
    m: Math.floor((diff / 60000) % 60),
    s: Math.floor((diff / 1000) % 60),
  };
};

const Digit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <div className="relative h-11 w-11 overflow-hidden sm:h-16 sm:w-16">
      <AnimatePresence mode="popLayout">
        <motion.span
          key={value}
          initial={{ y: 18, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -18, opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="font-display absolute inset-0 flex items-center justify-center text-2xl font-bold text-white sm:text-4xl"
        >
          {String(value).padStart(2, "0")}
        </motion.span>
      </AnimatePresence>
    </div>
    <span className="mt-1 text-[10px] uppercase tracking-[0.25em] text-white/40 sm:text-xs">
      {label}
    </span>
  </div>
);

export const Countdown = ({ testId }) => {
  const [t, setT] = useState(getTimeLeft());

  useEffect(() => {
    const id = setInterval(() => setT(getTimeLeft()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid={testId}
      className="flex items-center justify-center gap-2.5 rounded-2xl border border-white/10 bg-white/[0.03] px-3 py-4 backdrop-blur-md sm:gap-5 sm:px-6"
    >
      <Digit value={t.d} label="Days" />
      <span className="font-display pb-4 text-lg text-[#0f93cc] sm:text-2xl">:</span>
      <Digit value={t.h} label="Hrs" />
      <span className="font-display pb-4 text-lg text-[#0f93cc] sm:text-2xl">:</span>
      <Digit value={t.m} label="Min" />
      <span className="font-display pb-4 text-lg text-[#0f93cc] sm:text-2xl">:</span>
      <Digit value={t.s} label="Sec" />
    </div>
  );
};
